module.exports = {
    "id": "cycle",
    "color": "blue",
    "info": [
        {
            "text": "Make a piece appear and disappear again and again",
            "image": "provision/glitches/cycle/cycle.gif"
        }
    ],
    "title": "cycle",
    "icon": "hourglass",
    "category": "rules",
    "searchTags": ["disappear","appear","phase","blink","invisible","magic"],
    "exposedVariables": [
        {
            "tooltip":"Adjust the time between appearances and disappearances",
            "value": 1,
            "variableName": "cycle time",
            "spriteName": "$glitch_target",
            "input": {
                "type": "slider",
                "min": "0",
                "max": "10",
                "step": ".1"
            }
        }
    ],
    "codeImage": "provision/glitches/cycle/cycle.png",
    "code": null,
    "zip": null,
    "sb3": null
};